if (!customElements.get('quickshop-product-form')) {
  class QuickshopProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.formWrapper = this.closest('[data-quickshop-popup-form]')
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cartNotification = document.querySelector('cart-notification')
      this.cartDrawer = document.querySelector('cart-drawer')
      this.variantRadios = this.formWrapper.querySelector('variant-radios')
    }

    onSubmitHandler(evt) {
      evt.preventDefault()
      const self = this

      // Get the fieldsets from the variant selector and their values
      const fieldsets = Array.from(this.formWrapper.querySelector('variant-radios').querySelectorAll('fieldset'))
      const selectedOptionValues = fieldsets.map((fieldset) => {
        const elem = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
        return elem?.value
      })

      // Guard if all variant options have a value
      if (selectedOptionValues.some((item) => item === undefined)) {
        this.variantRadios.toggleVariantNotice(false, true)
        return
      }

      const submitButton = this.querySelector('[type="submit"]')
      submitButton.setAttribute('disabled', true)
      submitButton.classList.add('loading')
      submitButton.classList.add('button--active')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const sectionsToFetch = [...this.cartDrawer.getSectionsToRender().map((section) => section.id), ...this.cartNotification.getSectionsToRender().map((section) => section.id)]

      const formData = new FormData(this.form)
      formData.append('sections', sectionsToFetch)
      formData.append('sections_url', window.location.pathname)
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement)
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'))
            return
          }

          self.cartDrawer.renderContents(parsedState)
          self.cartDrawer.open()

          // If item was added from wishlist
          const wishlistItem = this.closest('[data-wk-item]')?.dataset?.wkItem

          if (wishlistItem && WishlistKing?.toolkit?.settings?.moveToCart) {
            WishlistKing.toolkit.removeItem(wishlistItem)
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          submitButton.classList.remove('loading')
          submitButton.removeAttribute('disabled')
          submitButton.classList.remove('button--active')

          // Close the popup
          this.closest('quick-shop').closePopup()
        })
    }
  }

  window.QuickshopProductForm = QuickshopProductForm
  customElements.define('quickshop-product-form', QuickshopProductForm)
}
